import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  reprocessParametersSelector,
  reprocessFilterStatusSelector,
  reprocessChangeFilterStatus,
} from '../../../state';
import {
  SimpleSelect,
  SimpleSelectOptionFormatter,
  SimpleSelectProps,
  useArrayToSimpleSelectOption,
} from '../../selects';

type StatusFilterProps = Pick<SimpleSelectProps, 'fullWidth'>;

const formatter: SimpleSelectOptionFormatter = {
  type: 'translation',
  translationIdBase: 'reprocess.statuses',
  sort: 'asc',
};

const StatusFilter = (props: StatusFilterProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const parameters = useSelector(reprocessParametersSelector);
  const options = useArrayToSimpleSelectOption(parameters.data?.statuses || [], formatter);
  const value = useSelector(reprocessFilterStatusSelector);
  const handleChange = useCallback(
    (value: string) => dispatch(reprocessChangeFilterStatus(value)),
    [dispatch]
  );

  return (
    <SimpleSelect
      {...props}
      label={t('reprocess.labels.status')}
      onChange={handleChange}
      value={parameters.loaded ? value : ''}
      options={options}
      loading={parameters.loading}
    />
  );
};

export default StatusFilter;
